<template>
  <div class="filter-container">
    <form novalidate @submit.prevent="searchForm">
      <div class="row">
        <div
          :class="[
            'col-12',
            hasActiveFilterPermission ? 'col-md-3' : 'col-md-4',
            { 'pt-2': isMobile },
          ]"
        >
          <custom-drop-down
            v-model="filter.category"
            :regular-label="isMobile"
            :options="categories"
            fieldkey="id"
            fieldname="name"
            placeholder="Seleccione Categoría"
          />
        </div>
        <div
          :class="[
            'col-12 ',
            hasActiveFilterPermission ? 'col-md-5 col-lg-6' : 'col-md-6',
            { 'pt-2': isMobile },
          ]"
        >
          <custom-input
            id="txtLocationName"
            v-model="filter.searchField"
            placeholder="Número o Título del formulario"
            icon="fa fa-search orange-icon"
            left-icon
          />
        </div>
        <div
          v-if="hasActiveFilterPermission"
          :class="['col-12 col-md-2 col-lg-1']"
        >
          <div class="mt-2">
            <div
              class="custom-control custom-checkbox custom-whitebg-checkbox"
              style="margin-top:10px"
            >
              <input
                id="chkActive"
                v-model="filter.isActive"
                type="checkbox"
                name="chkActive"
                class="custom-control-input"
              />
              <label for="chkActive" class="custom-control-label font bold">
                <span><em class="ic-check" /></span>
                Activo
              </label>
            </div>
          </div>
        </div>
        <div :class="['col-12 col-md-2', { 'pt-3': isMobile }]">
          <div :class="{ 'float-right': !isMobile }">
            <action-button
              type="submit"
              text="Buscar"
              variant="success"
              i="fas fa-search"
              :class="['px-4', { 'w-100': isMobile, 'ml-2': !isMobile }]"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import ActionButton from '@/components/common/ActionButton';
import CustomDropDown from '@/components/common/CustomDropDown';
import CustomInput from '@/components/common/CustomInput';
import formManagementApi from '@/modules/operation-form-management/api.js';

import { modulesName } from '@/modules';
import {
  actionTypes,
  getterTypes,
} from '@/modules/operation-form-management/store/types';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters, mapActions } = createNamespacedHelpers(
  modulesName.operationFormManagementModuleName
);

export default {
  name: 'FormSearch',
  components: {
    ActionButton,
    CustomDropDown,
    CustomInput,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      categories: getterTypes.GET_CATEGORIES,
      filter: getterTypes.GET_FILTER,
      pagination: getterTypes.GET_PAGINATION,
    }),
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
    hasActiveFilterPermission() {
      return this.$store.getters.HasPermission('form.management.active.filter');
    },
  },
  methods: {
    ...mapActions([actionTypes.FETCH_CATEGORIES, actionTypes.FETCH_RESULTS]),
    searchForm() {
      const filters = {
        categoryCode: this.filter.category?.id ?? '',
        searchField: this.filter.searchField,
        isActive: this.filter.isActive,
      };
      this[actionTypes.FETCH_RESULTS](filters);
    },
    getCategories() {
      formManagementApi.getCategories().then((res) => {
        const data = res.data ? res.data : [];
        this.categories = data;
      });
    },
  },
  async mounted() {
    await this[actionTypes.FETCH_CATEGORIES]();
  },
};
</script>

<style scoped>
.filter-container {
  background-color: #f4f6f3;
  padding: 15px;
  border-radius: 5px;
}
</style>
